import React from "react";
import "antd/dist/antd.css";
import { Form, Input, Row, Col } from "antd";
import * as actions from "../../Store/Actions/index";
import { connect } from "react-redux";

import {
  autoCodingTooltip,
  vendorCostSavingsTooltip,
  travelSavingTooltip,
  accurateBillingSavingTooltip,
  reducedClaimsSavingsTooltip,
  otherSavingsTooltip,
  benefitsExplanation,
} from "../../Util/writing";

import { getLabel, formatNumber, getHelp, getValidateStatus } from "../../Util/util";
import { getTotalBenefits } from "../Logics/benefitCalculations";

const smallFormItemLayout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};

const explanationDivStyle = {
  lineHeight: "1.15em",
  paddingTop: 20,
  paddingRight: 25,
  paddingLeft: 25,
  textAlign: "left",
};

const outputFormDivStyle = {
  marginBottom: 5,
  padding: 25,
  paddingTop: 10,
};

const TotalBenefits = (props) => {
  const updateBenefitAdjustAttr = (e) => {
    const inputField = e.currentTarget.id;
    const value = e.currentTarget.value;
    props.setBenefitsAttr({ [inputField]: value });
  };

  return (
    <React.Fragment>
      <Row>
        <Col xs={0} sm={8} md={8} lg={8} xl={8} />
        <Col xs={24} sm={16} md={16} lg={16} xl={16}>
          <div style={explanationDivStyle}>{benefitsExplanation}</div>
        </Col>
      </Row>

      <div style={outputFormDivStyle}>
        <Form {...smallFormItemLayout}>
          <Form.Item
            label={getLabel("Computer Assisted Coding", autoCodingTooltip)}
            validateStatus={getValidateStatus(props.benefitsDetails["auto-coding"])}
            help={getHelp(props.benefitsDetails["auto-coding"])}
          >
            <Input
              addonAfter={props.currency}
              placeholder=""
              id="auto-coding"
              onChange={updateBenefitAdjustAttr}
              className="numberInput"
              value={props.benefitsDetails["auto-coding"]}
            />
          </Form.Item>
          <Form.Item
            label={getLabel("Vendor Cost Savings", vendorCostSavingsTooltip)}
            validateStatus={getValidateStatus(props.benefitsDetails["vendor-costs-savings"])}
            help={getHelp(props.benefitsDetails["vendor-costs-savings"])}
          >
            <Input
              addonAfter={props.currency}
              placeholder=""
              id="vendor-costs-savings"
              onChange={updateBenefitAdjustAttr}
              className="numberInput"
              value={props.benefitsDetails["vendor-costs-savings"]}
            />
          </Form.Item>
          <Form.Item
            label={getLabel("Travel, Accommodation, and Resource Savings", travelSavingTooltip)}
            validateStatus={getValidateStatus(props.benefitsDetails["travel-saving"])}
            help={getHelp(props.benefitsDetails["travel-saving"])}
          >
            <Input
              addonAfter={props.currency}
              placeholder=""
              id="travel-saving"
              onChange={updateBenefitAdjustAttr}
              className="numberInput"
              value={props.benefitsDetails["travel-saving"]}
            />
          </Form.Item>
          <Form.Item
            label={getLabel("Accurate Billing for Procedures", accurateBillingSavingTooltip)}
            validateStatus={getValidateStatus(props.benefitsDetails["accurate-billing-saving"])}
            help={getHelp(props.benefitsDetails["accurate-billing-saving"])}
          >
            <Input
              addonAfter={props.currency}
              placeholder=""
              id="accurate-billing-saving"
              onChange={updateBenefitAdjustAttr}
              className="numberInput"
              value={props.benefitsDetails["accurate-billing-saving"]}
            />
          </Form.Item>
          <Form.Item
            label={getLabel("Reduction in Miscoded Reimbursement Claims", reducedClaimsSavingsTooltip)}
            validateStatus={getValidateStatus(props.benefitsDetails["reduced-claims-savings"])}
            help={getHelp(props.benefitsDetails["reduced-claims-savings"])}
          >
            <Input
              addonAfter={props.currency}
              placeholder=""
              id="reduced-claims-savings"
              onChange={updateBenefitAdjustAttr}
              className="numberInput"
              value={props.benefitsDetails["reduced-claims-savings"]}
            />
          </Form.Item>
          <Form.Item
            label={getLabel("Additional Benefits", otherSavingsTooltip)}
            validateStatus={getValidateStatus(props.benefitsDetails["other-savings"])}
            help={getHelp(props.benefitsDetails["other-savings"])}
          >
            <Input
              addonAfter={props.currency}
              placeholder=""
              id="other-savings"
              onChange={updateBenefitAdjustAttr}
              className="numberInput"
              value={props.benefitsDetails["other-savings"]}
            />
          </Form.Item>
          <Form.Item label="Total Benefits" help="">
            <Input
              addonAfter={props.currency}
              placeholder=""
              id="total-savings"
              disabled
              className="numberInput"
              value={formatNumber(getTotalBenefits())}
            />
          </Form.Item>
        </Form>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    currency: state.currency.currency,
    retrainCostDetails: state.costs.retrainCostDetails,
    prodLossDetails: state.costs.prodLossDetails,
    systemCostDetails: state.costs.systemCostDetails,
    costAdjustDetails: state.costs.costAdjustDetails,
    benefitsDetails: state.benefits.benefitsDetails,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setBenefitsAttr: (obj) => dispatch(actions.setBenefitsAttr(obj)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TotalBenefits);
